<!-- Contenu intérieur du sidebar "Sceau". Le <c-sidebar> hôte reste directement
     dans home.component.html : CoreUI calcule le décalage du contenu principal
     via un sélecteur CSS "frère" (~) qui ne fonctionne qu'entre éléments
     partageant le même parent — l'encapsuler ici casserait ce mécanisme. -->
<div class="sceau-brand">
  <img src="assets/etax/tresor-public-senegal-logo.png" alt="Logo eTax" class="sceau-logo" />
  <div class="sceau-brand-text">
    <div class="sceau-name">KOOM-COM </div>
    <div class="sceau-tagline">Trésor Public</div>
  </div>
</div>

<div class="sceau-search">
  <svg [cIcon]="icons.cilSearch" size="sm"></svg>
  <input type="text" [(ngModel)]="search" (ngModelChange)="apply_filter()" placeholder="Rechercher un menu…" />
</div>

<div class="sceau-sidebar-nav">
  <c-sidebar-nav [navItems]="filtered_nav_items"></c-sidebar-nav>
  <div class="sceau-empty" *ngIf="search && filtered_nav_items.length === 0">
    Aucun menu ne correspond à « {{search}} »
  </div>
</div>

<div class="sceau-user-card" *ngIf="api.infos?.agent">
  <div class="sceau-avatar">{{initiales}}</div>
  <div class="sceau-user-meta">
    <div class="u-name">{{nom_complet}}</div>
    <div class="u-role">{{role_label}}<ng-container *ngIf="contexte_label"> — {{contexte_label}}</ng-container></div>
  </div>
</div>

<c-sidebar-toggler toggle="unfoldable" cSidebarToggle="sidebarSceau"></c-sidebar-toggler>
